import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Touristbusrentalforsinhagadfort() {



const cardData =
{
  keyword: 'Tourist Bus Rental for Sinhagad Fort Trip',
  heading: 'Sanavi Travels: Tourist Bus Rental for Sinhagad Fort Trip',
  headingDescription: 'Sanavi Travels offers reliable and comfortable Tourist Bus Rental for Sinhagad Fort Trip, ideal for families, groups, corporates, students, and tourists planning a safe, organized, and enjoyable visit to the historic Sinhagad Fort near Pune.',

  top: 'Popular Travel Experiences for Sinhagad Fort Trip by Tourist Bus',

  "topPlaces": [
    {
      "title": "Historic Sinhagad Fort Exploration",
      "description": "Sinhagad Fort is one of Maharashtra’s most iconic historical landmarks, known for its Maratha legacy, scenic views, and cultural importance. Traveling by tourist bus allows groups to reach the base village comfortably and together, without worrying about narrow roads, parking issues, or traffic congestion near the fort. The journey itself builds excitement as travelers move from city roads into lush green surroundings and hill terrain. Group travel by bus ensures everyone arrives on time, follows the planned schedule, and enjoys the fort exploration without logistical stress. This is especially important for first-time visitors, school groups, and senior citizens who prefer organized and disciplined travel."
    },
    {
      "title": "Family Picnic Trip to Sinhagad Fort",
      "description": "Families often choose Sinhagad Fort for day picnics, weekend outings, and short heritage trips from Pune. Hiring a tourist bus ensures that all family members, including children and elders, travel together comfortably. Spacious seating, smooth suspension, and professional driving reduce fatigue and make the short journey pleasant. Families can carry food, picnic items, and personal belongings easily in the bus, avoiding multiple vehicles and coordination issues. The shared journey enhances bonding and allows families to enjoy the trip from start to finish."
    },
    {
      "title": "School & College Educational Tours",
      "description": "Sinhagad Fort is a popular destination for educational tours due to its historical significance and natural environment. Tourist bus rental is the safest and most practical option for schools and colleges, ensuring disciplined group travel, proper supervision, and adherence to schedules. Students benefit from safe seating, organized boarding, and guided travel, while teachers and organizers can manage the group efficiently. The bus becomes a controlled environment that supports learning, interaction, and safe transport throughout the trip."
    },
    {
      "title": "Corporate Team Outings & Day Trips",
      "description": "Corporate teams frequently plan short trips and team outings to Sinhagad Fort for trekking, team bonding, and informal meetings. Tourist bus hire supports professional and punctual transportation for employees, ensuring everyone travels together and reaches the destination on time. It eliminates the hassle of multiple cars, parking shortages, and late arrivals. Corporate groups can relax, interact, and enjoy the outing while the driver manages traffic and hill routes."
    },
    {
      "title": "Trekking & Adventure Groups",
      "description": "Sinhagad Fort attracts trekking and adventure enthusiasts throughout the year. Tourist buses are ideal for transporting trekking groups safely to the starting points. Early morning departures, safe driving on ghat roads, and sufficient luggage space for trekking gear make bus rental the preferred choice. Group travel by bus ensures everyone starts and ends the trek together, maintaining safety and coordination."
    },
    {
      "title": "Weekend Getaways from Pune",
      "description": "For Pune residents, Sinhagad Fort is a perfect weekend escape. Tourist bus rental allows groups to plan relaxed departures, avoid weekend traffic stress, and enjoy the short journey as part of the outing. The convenience of group travel makes weekend trips smoother, especially during peak tourist seasons when parking and road access become challenging."
    },
    {
      "title": "Monsoon Trips to Sinhagad Fort",
      "description": "During monsoon, Sinhagad Fort becomes extremely scenic with greenery, mist, and waterfalls, attracting large tourist crowds. Professional tourist bus drivers experienced in monsoon driving ensure safe navigation on slippery roads and steep sections. Well-maintained buses with reliable braking systems add an extra layer of safety, making bus travel the safest option during the rainy season."
    },
    {
      "title": "Stress-Free Group Coordination",
      "description": "Group travel to Sinhagad Fort often involves tight schedules and limited road access. Traveling in a single tourist bus eliminates coordination problems, communication gaps, and delays. Everyone arrives together, departs together, and follows the same plan, ensuring a smooth and stress-free group experience."
    },
    {
      "title": "Scenic Hill Route Journey",
      "description": "The drive towards Sinhagad Fort offers beautiful hill views, greenery, and fresh air. Traveling by tourist bus allows passengers to relax and enjoy the scenery without focusing on driving. Large windows and elevated seating enhance the visual experience, making the journey enjoyable even before reaching the fort."
    },
    {
      "title": "Safe & Disciplined Return Travel",
      "description": "After a day of trekking or sightseeing, safe return travel is crucial. Tourist buses provide a comfortable and secure return journey, especially when travelers are tired. Professional drivers ensure smooth downhill driving, controlled speed, and safe drop-offs back in Pune."
    }
  ],

  "services": [
    {
      "name": "Tourist Bus Rental for Sinhagad Fort Trip",
      "description": "Sanavi Travels provides dedicated tourist bus rental services for Sinhagad Fort trips, ensuring safe, organized, and comfortable group travel. Our buses are well-maintained, clean, and suitable for short hill journeys. Professional drivers handle narrow roads, hill sections, and tourist traffic efficiently, allowing passengers to enjoy the trip without stress. This service is ideal for families, schools, colleges, corporates, and tourist groups looking for reliable transport to Sinhagad Fort."
    },
    {
      "name": "AC Tourist Bus Sinhagad Fort",
      "description": "AC tourist buses offer a cool and comfortable environment for travelers, especially during summer trips to Sinhagad Fort. Climate-controlled interiors ensure passengers remain relaxed before and after trekking or sightseeing activities, making the journey pleasant for all age groups."
    },
    {
      "name": "Non AC Tourist Bus Sinhagad Fort",
      "description": "Non AC tourist buses provide an economical travel option for Sinhagad Fort trips during pleasant weather. These buses maintain safety and comfort standards while helping groups manage travel costs efficiently."
    },
    {
      "name": "Luxury Tourist Bus Hire Sinhagad Fort",
      "description": "Luxury tourist buses offer premium seating, smooth suspension, and enhanced comfort for special group outings, corporate trips, and premium family tours to Sinhagad Fort. They add a touch of comfort and elegance to short heritage journeys."
    },
    {
      "name": "Mini Bus on Rent Sinhagad Fort",
      "description": "Mini buses are suitable for small groups and families traveling to Sinhagad Fort. They offer flexibility, easy maneuverability on hill roads, and comfortable seating for compact group travel."
    },
    {
      "name": "32 Seater Tourist Bus Sinhagad Fort",
      "description": "32 seater tourist buses are ideal for medium-sized groups such as school batches, corporate teams, and extended families. They provide sufficient seating capacity, luggage space, and comfort for a smooth fort trip."
    },
    {
      "name": "35 Seater Tourist Bus Sinhagad Fort",
      "description": "35 seater tourist buses are perfect for large groups planning Sinhagad Fort trips. Traveling together in one vehicle ensures better coordination, safety, and time management throughout the journey."
    },
    {
      "name": "Tourist Bus for Family Sinhagad Fort",
      "description": "Family-focused tourist bus services ensure safe and relaxed travel for children, elders, and adults. Comfortable seating, flexible departure timings, and safe driving make family fort trips enjoyable."
    },
    {
      "name": "Tourist Bus for Corporate Sinhagad Fort",
      "description": "Corporate tourist bus hire supports team outings, day trips, and employee engagement activities at Sinhagad Fort. Professional transport ensures punctuality, discipline, and smooth group movement."
    },
    {
      "name": "Affordable Tourist Bus Rental Sinhagad Fort",
      "description": "Affordable bus rental packages are designed to provide value-for-money transport without compromising safety or comfort. Transparent pricing helps groups plan their trips confidently."
    },
    {
      "name": "Best Tourist Bus Service Sinhagad Fort",
      "description": "Sanavi Travels is known for dependable tourist bus services for Sinhagad Fort trips, offering consistent quality, experienced drivers, and customer-focused support."
    },
    {
      "name": "Tourist Bus with Driver Sinhagad Fort",
      "description": "All tourist bus rentals include professional drivers experienced with Sinhagad Fort routes, hill driving, and tourist traffic, ensuring a safe and comfortable journey."
    },
    {
      "name": "Tourist Bus for Wedding Sinhagad Fort",
      "description": "Tourist buses can be used for wedding-related group travel and family gatherings near Sinhagad Fort, ensuring coordinated and comfortable transport for guests."
    },
    {
      "name": "Tourist Bus for Picnic Sinhagad Fort",
      "description": "Picnic trips to Sinhagad Fort become easier with tourist bus hire, allowing groups to carry food, supplies, and picnic gear comfortably while enjoying the journey."
    },
    {
      "name": "Outstation Tourist Bus Sinhagad Fort",
      "description": "Outstation tourist bus services support groups traveling from nearby cities to Sinhagad Fort, ensuring smooth and reliable long-distance travel with planned stops."
    }
  ],

  "tableData": [
    ["Sinhagad Fort Tourist Bus", "AC Tourist Bus"],
    ["Non AC Tourist Bus", "Luxury Tourist Bus"],
    ["32 Seater Bus", "35 Seater Bus"],
    ["Family Trips", "Corporate Trips"],
    ["Picnic Tours", "Educational Tours"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Hill Route Experienced Drivers", "WhyChoosedescription": "Drivers skilled in ghat and fort routes." },
    { "WhyChooseheading": "Safe Group Travel", "WhyChoosedescription": "Ideal for families, students, and corporates." },
    { "WhyChooseheading": "Comfortable Short Journeys", "WhyChoosedescription": "Smooth and relaxed ride quality." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "Mini, standard, and luxury buses available." },
    { "WhyChooseheading": "Affordable Pricing", "WhyChoosedescription": "Cost-effective packages with transparency." },
    { "WhyChooseheading": "Well-Maintained Fleet", "WhyChoosedescription": "Clean and regularly serviced buses." },
    { "WhyChooseheading": "Group Coordination", "WhyChoosedescription": "Entire group travels together." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for reliability." }
  ]
};

const faqData = [
  { question: 'Do you provide tourist bus rental for Sinhagad Fort?', answer: 'Yes, Sanavi Travels offers tourist bus rental services for Sinhagad Fort trips.' },
  { question: 'Is bus travel safe for Sinhagad Fort?', answer: 'Yes, our drivers are experienced with hill and fort routes.' },
  { question: 'Are AC buses available for Sinhagad Fort trips?', answer: 'Yes, AC tourist buses are available.' },
  { question: 'Can families book a bus for Sinhagad Fort?', answer: 'Yes, family-friendly tourist buses are available.' },
  { question: 'Do you provide buses for school trips?', answer: 'Yes, school and college educational tours are supported.' },
  { question: 'Is this suitable for corporate outings?', answer: 'Yes, corporate group travel is available.' },
  { question: 'Are drivers included in the rental?', answer: 'Yes, all rentals include professional drivers.' },
  { question: 'Is luggage space available?', answer: 'Yes, buses have space for bags and picnic items.' },
  { question: 'Can we customize pickup points?', answer: 'Yes, pickup and drop locations can be customized.' },
  { question: 'How can I book a bus for Sinhagad Fort trip?', answer: 'You can book via our website or customer support.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Kulkarni',
    feedback: 'Our Sinhagad Fort trip by tourist bus was very comfortable and well-organized.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Patil',
    feedback: 'Safe driving, clean bus, and smooth experience. Highly recommended!',
    rating: 5
  }
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];




const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tourist Bus Rental for Sinhagad Fort Trip - Sanavi Travels",
  "description": "Sanavi Travels offers tourist bus rentals for Sinhagad Fort trips, including family travel, corporate tours, weddings, picnics, and outstation journeys. AC and Non-AC buses, luxury buses, 32-seater and 35-seater options, and mini buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Tourist Bus Rental for Sinhagad Fort Trip | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book tourist buses for Sinhagad Fort trips with Sanavi Travels. AC & Non-AC luxury buses, 32-seater, 35-seater, and mini buses for family travel, corporate tours, weddings, picnics, and outstation journeys with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/289.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Touristbusrentalforsinhagadfort;